import API from './api/api';
import utils from './utils';
import * as Sentry from '@sentry/browser';
import { toast } from 'react-toastify';

const modules = {
	API,
	utils,
	Sentry,
	toast
};

export default modules;